import React, { useEffect, useState } from "react";
import { useAnalytics } from "@piiqtechnologies/ui-lib";
import { CardLayout } from "../CustomSubtopicCardLayout";
import { CommuteRow } from "./CommuteRow";
export const CommuteCard = ({ title, subtitle, tooltip, initialCommuteItems, baseCount, canAddMore, maxSubtopics, onAddedCountChange, onCommuteItemsChange, saveTrigger, onEditingCountChange, readOnly, hasBeenRun, }) => {
    const analytics = useAnalytics();
    const defaultCount = baseCount !== null && baseCount !== void 0 ? baseCount : initialCommuteItems.length;
    const [items, setItems] = useState(initialCommuteItems);
    const [editingNewIndex, setEditingNewIndex] = useState(null);
    const addedCount = items.length - defaultCount;
    useEffect(() => {
        onAddedCountChange === null || onAddedCountChange === void 0 ? void 0 : onAddedCountChange(addedCount);
    }, [addedCount, onAddedCountChange]);
    useEffect(() => {
        onCommuteItemsChange === null || onCommuteItemsChange === void 0 ? void 0 : onCommuteItemsChange(items);
    }, [items, onCommuteItemsChange]);
    const handleEdit = (index, item) => {
        if (!item) {
            analytics.track("Custom Subtopics | Subtopic Removed", { category: title, index });
            setItems((prev) => prev.filter((_, i) => i !== index));
            return;
        }
        analytics.track("Custom Subtopics | Subtopic Edited", { category: title, index, destination: item.destination });
        setItems((prev) => prev.map((existing, i) => (i === index ? item : existing)));
    };
    const handleDelete = (index) => {
        analytics.track("Custom Subtopics | Subtopic Deleted", { category: title, index });
        setItems((prev) => prev.filter((_, i) => i !== index));
    };
    const handleAddSubtopic = () => {
        analytics.track("Custom Subtopics | Add Subtopic Clicked", { category: title });
        setItems((prev) => [...prev, { minutes: 40, transportMode: "public-transit", destination: "" }]);
        setEditingNewIndex(items.length);
    };
    return (React.createElement(CardLayout, { title: title, subtitle: subtitle, tooltip: tooltip, canAddMore: canAddMore, maxSubtopics: maxSubtopics, onAddSubtopic: handleAddSubtopic, readOnly: readOnly, hasBeenRun: hasBeenRun },
        React.createElement(CommuteRow, { items: items, defaultCount: defaultCount, onEdit: handleEdit, onDelete: handleDelete, editingNewIndex: editingNewIndex, onEditingNewHandled: () => setEditingNewIndex(null), saveTrigger: saveTrigger, onEditingCountChange: onEditingCountChange, readOnly: readOnly, hasBeenRun: hasBeenRun })));
};
